$( window ).load(function() {
    // Rename certain h3
    $("h3:contains(Production)").text("Turnaround");
    $("h3:contains(Materials)").text("Printing");

    // Move additionalProductFields inside printing section
    $('#lfVariousSettings').contents().appendTo('#lfConstruction');

    //Move finishing option to printing section
    $('#operationsDiv').appendTo('#lfConstruction');
});